import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('INVENTORY_BOOK', ['MAIN', 'FILTER_FORM'])
